import React from "react";
import Layout from "@/components/Layout";
import ChatThread from "@/components/ChatThread";
import { MessageCircle } from "lucide-react";

export default function Messages() {
  return (
    <Layout>
      <div className="label-eyebrow mb-3">Direct line</div>
      <div className="flex items-center gap-3 mb-3">
        <MessageCircle size={22} strokeWidth={1.6} className="text-brand-primary" />
        <h1 className="font-serif text-4xl sm:text-5xl font-light text-stone-900">Messages with your coach</h1>
      </div>
      <p className="max-w-2xl text-stone-600 leading-relaxed mb-8">
        A quiet, direct channel to your coach between sessions – ask a question, share a win,
        or flag something you're sitting with.
      </p>
      <div className="max-w-3xl">
        <ChatThread participantId={null} height="h-[520px]" />
      </div>
    </Layout>
  );
}
